import { render } from "./FaqIcon.vue?vue&type=template&id=6ef8bd74&scoped=true"
import script from "./FaqIcon.vue?vue&type=script&lang=js"
export * from "./FaqIcon.vue?vue&type=script&lang=js"

import "./FaqIcon.vue?vue&type=style&index=0&id=6ef8bd74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef8bd74"]])

export default __exports__